export const lowercaseWords = [
  'og',
  'eller',
  'men',
  'for',
  'så',
  'at',
  'om',
  'av',
  'til',
  'med',
  'på',
  'i',
  'fra',
  'ved',
  'under',
  'etter',
  'uten',
  'mellom',
  'over',
  'mot',
  'hos',
  'enn',
  'omkring',
  'blant',
  'innen',
  'ifølge',
  'ifall',
  'a',
  'an',
  'the',
  'to',
  'and',
  'but',
  'or',
  'nor',
  'for',
  'on',
  'in',
  'with',
  'at',
  'by',
  'from',
  'of'
];
